import React, { lazy, Suspense } from 'react';
import { HashRouter as Router, Switch, Redirect, Route } from "react-router-dom";
import Routes from './Component/Routes/Routes';
import RouteWithSubRoutes from './Component/Routes/RouteWithSubRoutes';
import { ComponentLoader } from './Component/ComponentLoader/ComponentLoader';

// const ResponsiveLogin = lazy(() => import('./Component/Login/ResponsiveLogin'))
const PageNotFound = lazy(() => import('./Component/MainPage/PageNotFound'))

function App() {
  return (
    <Router>
      <Suspense fallback={<ComponentLoader />}>
          <Switch>
            <Redirect exact from='/' to='/Login' />
            {Routes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
            ))}
            <Route component={PageNotFound} />
          </Switch>
        </Suspense>
    </Router>
  );
}

export default App;
